import styled, { css } from "styled-components";

export const CardContainer = styled.div`
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.1),
        rgba(255, 255, 255, 0)
    );
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    justify-items: center;
    color: white;
    align-content: center;
    text-align: center;
    z-index: 11;

    ${({ invitado }) =>
        invitado &&
        `
    background: black;
  `}
`;

export const CardProfile = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 2vh;
    text-align: center;
`;

export const CardName = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ImgWrap = styled.div`
    max-height: 300px;
    max-width: 300px;
    background-color: white;
    border-radius: 50%;
`;

export const Img = styled.img`
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 50%;
`;

export const CardInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 2vh;
`;

export const CardH2 = styled.h2`
    color: var(--impactColor);
    margin: 0;
`;

export const CardH3 = styled.h3`
    display: flex;
    justify-content: center;
    gap: 5px;
`;

export const CardSpan = styled.h3`
    padding: 10px 20px;
    border-radius: 20px;

    ${({ invitado }) =>
        invitado &&
        `
        width: fit-content;
        background: #fff;
        color: black;
  `};
    ${(props) =>
        props.LSST === "TVS" &&
        css`
            background: rgb(9, 0, 164);
            background: linear-gradient(
                270deg,
                rgba(9, 0, 164, 1) 0%,
                rgba(0, 29, 74, 1) 100%,
                rgba(0, 116, 255, 1) 100%
            );
        `};
    ${(props) =>
        props.LSST === "ISSC" &&
        css`
            background: rgb(14, 33, 56);
            background: linear-gradient(
                270deg,
                rgba(14, 33, 56, 1) 0%,
                rgba(76, 125, 184, 1) 100%,
                rgba(39, 71, 110, 1) 100%
            );
        `}
    ${(props) =>
        props.LSST === "GALAXIES" &&
        css`
            background: rgb(34, 193, 195);
            background: linear-gradient(
                0deg,
                rgba(34, 193, 195, 1) 0%,
                rgba(0, 105, 146, 1) 100%
            );
        `}
        ${(props) =>
        props.LSST === "SWMLV" &&
        css`
            background: rgb(63, 94, 251);
            background: radial-gradient(
                circle,
                rgba(63, 94, 251, 1) 0%,
                rgba(252, 70, 107, 1) 100%
            );
        `}
        ${(props) =>
        props.LSST ===
            ("SWMLV", "Uso de estación DS3", "ACTIVE GALAXY NUCLEI") &&
        css`
            background: rgb(63, 94, 251);
            background: radial-gradient(
                circle,
                rgba(63, 94, 251, 1) 0%,
                rgba(252, 70, 107, 1) 100%
            );
        `}
        ${(props) =>
        props.LSST === "DESC" &&
        css`
            background: rgb(131, 58, 180);
            background: linear-gradient(
                90deg,
                rgba(131, 58, 180, 1) 0%,
                rgba(253, 29, 29, 1) 50%,
                rgba(252, 176, 69, 1) 100%
            );
        `}
        ${(props) =>
        props.LSST === "SOLAR SYSTEM" &&
        css`
            background: rgb(84, 244, 246);
            background: linear-gradient(
                0deg,
                rgba(84, 244, 246, 1) 0%,
                rgba(0, 105, 146, 1) 100%
            );
        `}
        ${(props) =>
        props.LSST === "Uso de estación DS3" &&
        css`
            background: rgb(40, 171, 255);
            background: radial-gradient(
                circle,
                rgba(40, 171, 255, 1) 0%,
                rgba(31, 65, 94, 1) 100%
            );
        `}
        ${(props) =>
        props.LSST === "STRONG LENSING" &&
        css`
            background: rgb(63, 120, 251);
            background: radial-gradient(
                circle,
                rgba(63, 120, 251, 1) 0%,
                rgba(164, 70, 252, 1) 100%
            );
        `}
`;

export const CardH1 = styled.h1``;

export const CardP = styled.p``;

export const User = styled.div`
    min-width: 10vh;
    min-height: 10vh;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    border-radius: 50%;
    padding: 5px;
    color: black;

    @media (max-width: 450px) {
        min-width: 15vh;
        min-height: 10vh;
    }
`;

export const Button = styled.button`
    border-radius: 50px;
    background-color: var(--impactColor);
    white-space: nowrap;
    padding: 14px 48px;
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    color: var(--primaryColor);
    font-weight: bold;
    transition: 0.3s ease-out;
    transform: translateY(0);
    align-self: center;

    &:hover {
        transition: 0.2s;
        transform: translateY(-5px);
        background-color: #fff;
    }
`;
